import React from 'react'
import {Button} from 'antd'; 
import './rewarddigital.css';

function Rewarddigital1() {
    return (
        <div className='reward-body1'>
             
            <img alt='digital' src='../images/awards.jpg' className='image-awards1' />
            <div className='digital-button'>         
                   <Button className='proposal-button1'>GROW MY LEADS NOW</Button>
            </div>
        </div>
    )
}

export default Rewarddigital1;